import type { FilterOption, IFilter } from '@models/Filter'

import { endOfDay, startOfDay } from './date-util'

const createFilters = (input) => {
  const {
    fromDate,
    toDate,
    search,
    searchOption,
    gebied,
    processtap,
    active,
    kpi,
    netbeheerder,
    type,
    actiehouder,
    actie,
    uitvoerende,
  } = input
  const filters: IFilter[] = []

  if (fromDate)
    filters.push({
      name: 'aanvraagDatum',
      value: startOfDay(fromDate),
      operator: 'gte',
    })
  if (toDate)
    filters.push({
      name: 'aanvraagDatum',
      value: endOfDay(toDate),
      operator: 'lte',
    })
  if (search && search !== '') {
    if (searchOption)
      filters.push({ name: searchOption.k, value: search, operator: 'eq' })
    else filters.push({ name: 'text', value: search, operator: 'contains' })
  }
  if (gebied && gebied.length > 0)
    filters.push({
      name: 'coordinerende.gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  if (processtap && processtap.length > 0)
    filters.push({ name: 'statusText', value: processtap, operator: 'in' })

  if (active) filters.push({ name: 'isActive', value: active, operator: 'eq' })

  if (kpi) filters.push({ name: 'kpi.rag', value: kpi, operator: 'eq' })
  if (netbeheerder)
    filters.push({ name: 'netbeheerders', value: netbeheerder, operator: 'eq' })

  if (type && type.length > 0)
    filters.push({
      name: 'type',
      value: type.map(({ code }) => code),
      operator: 'in',
    })
  if (actiehouder)
    filters.push({ name: 'actiehouders', value: actiehouder, operator: 'eq' })
  if (actie)
    filters.push({
      name: `acties.${actie.code}`,
      value: actiehouder ? actiehouder : { $exists: true, $not: { $size: 0 } },
      operator: 'eq',
    })

  if (uitvoerende)
    filters.push({ name: 'uitvoerende', value: uitvoerende, operator: 'eq' })

  return filters
}

const initialFilterParams = {
  fromDate: null,
  toDate: null,
  search: '',
  searchOption: null,
  gebied: [],
  processtap: [],
  active: true,
  netbeheerder: null,
  type: [],
  actiehouder: null,
  actie: null,
}

/** Zet een lijst met waarden om naar opties voor een filter */
const toFilterOptions = (values: string[]): FilterOption[] =>
  values.map((value) => ({ code: value, label: value }))

const defaultIsOptionEqualToValue = (a: FilterOption, b: FilterOption) =>
  a.code === b.code

export {
  createFilters,
  initialFilterParams,
  defaultIsOptionEqualToValue,
  toFilterOptions,
}
